import { getFatalError, getMarketingState } from '@common/state/selectors'
import { AppState } from 'app-store'
import { getCheckoutState, getLabelContent } from '@buy/state/selectors'
import { BuyCheckoutFormSubmissionState } from './state'

export const mapBuyCheckoutFormSubmissionState = (state: AppState): BuyCheckoutFormSubmissionState => {
    const { completePurchase, pricingNote, optOut, optOutCheckboxLabel, checkoutCTAButtonText } = getLabelContent(state)
    const { isFatalError, fatalErrorBlocker } = getFatalError(state)
    const { totalLoading, calculatedTotal } = getCheckoutState(state)
    const { displayOptOut } = getMarketingState(state)

    return {
        content: { completePurchase, pricingNote, optOut, optOutCheckboxLabel, checkoutCTAButtonText },
        isFatalError,
        fatalErrorBlocker,
        totalLoading,
        displayOptOut,
        calculatedTotal,
        disablePlanSelection: false,
    }
}

export const mapBuyCheckoutFormSubmissionActions = {}

export type BuyCheckoutFormSubmissionActionsType = typeof mapBuyCheckoutFormSubmissionActions
